<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">
        <h4 class="personal-details-title">Add Offer</h4>
        <div [formGroup]="form">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Name <span class="required-field">*</span></label>
                <input formControlName="name" type="text" class="form-control">
                <span class="err" *ngIf="form.get('name').invalid && formSubmitted">name required</span>
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Description <span class="required-field">*</span></label>
                <textarea class="form-control" formControlName="description" name="" id="" cols="30" rows="10"></textarea>
                <span class="err" *ngIf="form.get('description').invalid && formSubmitted">description required</span>
              </div>
            </div>
            <div class="col-md-12 col-lg-12 submit-b">
              <button class="btn btn-primary" *ngIf="!addButton" (click)="addOffer()">Submit</button>
            </div>
          </div>
        </div>  
      </div>   
    </div>
  </div>
</div>